import React from 'react';
import ForgotPasswordForm from './ForgotPasswordForm';
import RestorePasswordForm from './RestorePasswordForm';
import APIService from '../../../services/APIService';


const ForgotPassword = ({ onBack, hash, passwordChange }) => {

    return (
        <div>
            <div className='form-content'>
                {hash ? (
                    <RestorePasswordForm hash={hash} onBack={onBack} />
                ) : (
                    <ForgotPasswordForm onBack={onBack} passwordChange={passwordChange} />
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;      